import { useEffect, useState } from 'react';
import useHttp from '../../../../../hooks/use-http';
import toast from 'react-hot-toast';
import GridProviderFajlovi from './GridProviderFajlovi';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import NoviFajl from './NoviFajl';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../../UI/Modal/Spinner';
import styles from './Files.module.css';
import { formatDateToDB } from '../../../../../../utils/FormatDate';
import LoaderProgress from '../../../PregledRadnogNaloga/Dnevnik/components/LoaderProgress';
import PregledSlikaGalery from '../../../../UI/PregledSlikaGalery/PregledSlikaGalery';
import PregledSlikaPopupUniverzalno from '../../../../UI/PregledSlika/PregledSlikaPopupUniverzalno';
import { getBaseUrl } from '../../../../../../utils/getUrl';
import axios from 'axios';

const INITIAL_VALUES = {
  id: 0,
  nazivFajla: '',
  nazivJezika: '',
  idJezika: 0,
  nazivGlavnaKategorija: '',
  idGlavnaKategorija: 0,
  nazivKategorije: '',
};

const Fajlovi = ({ id }) => {
  const {
    sendRequest: getGridData,
    data: gridData,
    isLoading: isLoadingGrid,
  } = useHttp('');
  const api = getBaseUrl();
  const [selectedImg, setSelectedImg] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const { getData: insertFajlova, isLoading: loadingFajlovi } = useHttp('');
  const { t } = useTranslation();
  const { getData, isLoading } = useHttp('');
  const [openDocument, setOpenDocument] = useState(false);
  const [openNewDocument, setOpenNewDocument] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [documentId, setDocumentId] = useState(0);
  const [formData, setFormData] = useState(INITIAL_VALUES);
  const [file, setFile] = useState([]);
  const [openPath, setOpenPath] = useState(null);

  const vratiGrid = () => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/vrati_dokumenta_objekta',
      data: {
        idObjekta: id,
        objekat: 'RNDnevnik',
      },
    };
    getGridData(config);
  };
  useEffect(() => {
    vratiGrid();
  }, []);
  const handleOpenFile = (item) => {
    if (item.type && item.type.startsWith('image')) {
      setSelectedImg(item.path);
    } else {
      setOpenPath(item.path);
      setOpenDocument(true);
    }
  };
  const handleOpenNewDocument = () => {
    setFormData(INITIAL_VALUES);
    setOpenNewDocument(true);
  };
  const handleNovi = () => {
    setFormData(INITIAL_VALUES);
    setFile([]);
  };

  const handleSaveDokument = async () => {
    const fd = new FormData();
    fd.append('IdVrsteDokOpste', 0);
    fd.append('objekat', 'RNDnevnik');
    fd.append('IdObjekta', id);
    fd.append('NazivFajla', null);
    fd.append('IdJezika', 0);
    fd.append('Kategorija', null);
    fd.append('Datum', formatDateToDB(new Date()));
    fd.append('IdKorProm', +localStorage.idKorisnika);
    file.forEach((item) => {
      fd.append('Dokumenti', item);
      fd.append('name', item.name);
      fd.append('size', item.size);
      fd.append('type', item.type);
    });
    const config = {
      method: 'POST',
      url: 'Dokumenta/unos_dokumenta',
      data: fd,
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setProgress(percent);
        }
      },
    };

    const result = await insertFajlova(config);
    if (result) {
      toast.success(t('dataAddedSuccessfully'));
      setFile([]);
      handleNovi();
      setOpenNewDocument(false);
      vratiGrid();
      setProgress(0);
    }
  };
  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setDocumentId(id);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/brisanje_dokumenta_objekta',
      data: { id: documentId },
    };
    const result = await getData(config);
    if (result) {
      setDocumentId(0);
      setOpenDeleteDialog(false);
      vratiGrid();
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  // const downloadFile = async (fileUrl, fileName) => {
  //   const config = {
  //     method: 'POST',
  //     url: 'Dokumenta/konvertovanje_base64',
  //     data: { vrednost: fileUrl },
  //   };

  //   const response = await getData(config);

  //   const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

  //   // Konvertovanje base64 stringa u Blob objekt
  //   const byteCharacters = atob(base64Data);
  //   const byteNumbers = Array.from(byteCharacters, (char) =>
  //     char.charCodeAt(0),
  //   );
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: 'application/octet-stream' });

  //   // Kreiranje URL-a za Blob objekt
  //   const blobUrl = URL.createObjectURL(blob);

  //   // Kreiranje i klikanje na link element za preuzimanje datoteke
  //   const link = document.createElement('a');
  //   link.href = blobUrl;
  //   link.setAttribute('download', fileName); // Postavite naziv datoteke
  //   document.body.appendChild(link);
  //   link.click();

  //   // Čišćenje URL-a i uklanjanje linka
  //   URL.revokeObjectURL(blobUrl);
  //   document.body.removeChild(link);
  // };

  const [downloading, setDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const downloadFile = async (fileUrl, fileName) => {
    try {
      setDownloading(true);
      setDownloadProgress(0);

      const apiUrl = `${api}Dokumenta/konvertovanje_base64_download?url=${encodeURIComponent(
        fileUrl,
      )}`;

      const response = await axios.get(apiUrl, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          console.log(progressEvent);
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            setDownloadProgress(percent);
          }
        },
      });

      const blob = new Blob([response.data]);

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName || '');

      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download greška:', error);
    } finally {
      setDownloading(false);
      setDownloadProgress(0);
    }
  };

  return (
    <div>
      {isLoading && <Spinner />}{' '}
      {downloading && <LoaderProgress progress={downloadProgress} />}
      {localStorage.idFirme === '1' && (
        <div
          style={{ cursor: 'pointer', width: 'fit-content' }}
          onClick={handleOpenNewDocument}
        >
          <i className="fas fa-plus-circle" /> {t('newFile')}
        </div>
      )}
      <GridProviderFajlovi
        data={gridData}
        loading={isLoadingGrid}
        handleOpenFile={handleOpenFile}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        downloadFile={downloadFile}
      />
      <MuiDialog
        maxWidth="md"
        open={openDocument}
        title="DOCUMENT"
        content={
          <iframe
            className={styles.fileContainer}
            src={openPath}
            title="File"
          />
        }
        handleClose={() => setOpenDocument(false)}
        deniedText="ZATVORI"
      />{' '}
      {selectedImg && (
        <PregledSlikaPopupUniverzalno
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
        />
      )}
      <MuiDialog
        maxWidth="sm"
        open={openNewDocument}
        title={t('newDocument')}
        content={
          <div>
            {' '}
            {loadingFajlovi && <LoaderProgress progress={progress} />}
            <NoviFajl setFile={setFile} file={file} />
          </div>
        }
        handleClose={() => setOpenNewDocument(false)}
        handleConfirm={handleSaveDokument}
        deniedText={t('close')}
      />{' '}
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Fajlovi;
